import { render } from "./StockNearExpiryReport.vue?vue&type=template&id=74829774&scoped=true&ts=true"
import script from "./StockNearExpiryReport.vue?vue&type=script&lang=ts"
export * from "./StockNearExpiryReport.vue?vue&type=script&lang=ts"

import "./StockNearExpiryReport.vue?vue&type=style&index=0&id=74829774&scoped=true&lang=css"

import exportComponent from "/home/lahiru-dhananjaya/Documents/Jeewaka/PMS/Source and Documentation/pharma-connect2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74829774"]])

export default __exports__